import { defineComponent } from "vue";

export default defineComponent({
  template: `
      <div class="cookie-banner__category">
        <div 
            :class="{
              'cookie-banner__category-heading': true,
            }" 
            @click="this.toggleConsentCategory()"
        >
          <p class="cookie-banner__category-title">
            <slot name="title"></slot>
          </p>
          <div class="cookie-banner__category-toggle">
            <label class="toggle">
              <input 
                  class="toggle__checkbox"
                  type="checkbox"
                  :checked="this.modelValue"
                  :disabled="this.disabled"
                  @input="this.onInput"
              >
                <span class="toggle__container">
                  <span class="toggle__circle">
                  </span>
                </span>
            </label>
          </div>
        </div>
        <div :class="{'cookie-banner__category-detail': true, 'visible': this.expanded}">
          <slot name="detail"></slot>
        </div>
      </div>
    `,
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    toggleConsentCategory() {
      this.expanded = !this.expanded;
    },
    onInput(event: Event) {
      const target = event.target as HTMLInputElement;
      this.$emit("update:modelValue", target.checked);
    },
  },
});
